const metaKeyCharacter = window.navigator.platform.match(/mac/i) ? '⌘' : 'Ctrl-'
export default metaKeyCharacter
